import Radium from 'radium';
import React from 'react';
import { Link } from 'react-router-dom';

const RadiumLink = Radium(Link);
const StyledLink = props => <RadiumLink {...props} />;

export default Radium(StyledLink);
